<div *ngIf="theming$ | async as theming" class="flex justify-content-center mt-5 mbc-55">
  <div class="flex justify-content-between md:w-30rem w-22rem">
    <div class="p-0">
      <img [src]="((merchantLogo$ | async) || '') | trustUrl" alt="{{merchantName$ | async}}" class="vertical-align-middle"
           width="130" height="49.73"/>
    </div>

    <div class="flex align-items-center justify-content-between">
      <button pRipple pButton type="button" label="{{language$ | async | uppercase}}"
              class="text-center min-w-min p-button-text px-2 mr-1"
              [style.background-color]="theming?.buttonSecondaryBgColor"
              [style.color]="theming?.buttonSecondaryTextColor"
              (click)="op.toggle($event)"></button>
      <p-overlayPanel #op>
        <ng-template pTemplate>
          <ul class="uppercase list-none p-0 m-0 text-center font-medium" [style.color]="theming?.buttonSecondaryTextColor">
            <li *ngFor="let lang of languages" class="lang-hover m-2 cursor-pointer"
                role="button" tabindex="0"
                (click)="changeLanguage(lang, op)"
                (keydown)="onLanguageKeydown($event, lang, op)">{{lang}}</li>
          </ul>
        </ng-template>
      </p-overlayPanel>
      <button pRipple *ngIf="merchantShoppingCartRedirectUrl$ | async as url" pButton type="button"
              class="px-2 w-6rem p-button-text text-justify"
              [style.background-color]="theming?.buttonSecondaryBgColor"
              [style.color]="theming?.buttonSecondaryTextColor"
              pTooltip="{{'header.cancelPayment.tooltip' | translate}}
                   {{additionText ? ('header.cancelPayment.tooltip.addition' | translate) : ''}}"
              (click)="navigateToMerchant(url)"
      ><span>{{'header.cancelPayment' | translate}}</span><span class="pl-1 pi pi-times"></span></button>
    </div>
  </div>
</div>

